import { render, staticRenderFns } from "./ModalFair.vue?vue&type=template&id=bcbaf6aa&scoped=true"
import script from "./ModalFair.vue?vue&type=script&lang=js"
export * from "./ModalFair.vue?vue&type=script&lang=js"
import style0 from "./ModalFair.vue?vue&type=style&index=0&id=bcbaf6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbaf6aa",
  null
  
)

export default component.exports